
import { FormState__startLoading, FormState__setValidationResponse_5219762A, FormState_get_empty, RequestedValue$1 } from "../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { updateCustomerConfiguration, getCustomerConfiguration } from "../../Requests/Configuration.js";
import { ofArray, singleton } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { CustomerConfigurationUpdate__applyTo_Z37090ACA, CustomerConfigurationUpdate, CustomerConfigurationUpdate_get_empty } from "../../Shared/CustomerConfigurationUpdate.js";

export const initialState = new State(new RequestedValue$1(0, []), FormState_get_empty());

export function init() {
    return [initialState, Cmd_batch(singleton(getCustomerConfiguration((Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(4, [Item_1])))))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.FormState), Cmd_none()];
        case 2: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                const validationResponse = response_1.fields[0];
                let globalValidationToast;
                const matchValue_1 = validationResponse.GlobalValidationMessage;
                globalValidationToast = ((matchValue_1 == null) ? Cmd_none() : Cmd_errorToast(matchValue_1));
                return [new State(state.CustomerConfiguration, FormState__setValidationResponse_5219762A(state.FormState, validationResponse)), Cmd_batch(ofArray([globalValidationToast, getCustomerConfiguration((Item_4) => (new Msg(1, [Item_4])), (Item_5) => (new Msg(4, [Item_5])))]))];
            }
            else {
                return [new State(state.CustomerConfiguration, FormState_get_empty()), Cmd_batch(ofArray([Cmd_successToast("settings.permissions_changed_successful"), getCustomerConfiguration((Item_2) => (new Msg(1, [Item_2])), (Item_3) => (new Msg(4, [Item_3])))]))];
            }
        }
        case 3:
            return [new State(state.CustomerConfiguration, FormState_get_empty()), Cmd_batch(ofArray([Cmd_errorToast("general.a_error_occured"), getCustomerConfiguration((Item_6) => (new Msg(1, [Item_6])), (Item_7) => (new Msg(4, [Item_7])))]))];
        case 4:
            return [new State(state.CustomerConfiguration, FormState_get_empty()), Cmd_none()];
        default: {
            const matchValue = state.CustomerConfiguration;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                let update_1;
                const bind$0040 = CustomerConfigurationUpdate_get_empty();
                update_1 = (new CustomerConfigurationUpdate(bind$0040.IsReleaseDateEnabled, bind$0040.GlobalSelfServiceStorageActive, bind$0040.IsStorageSelfServiceUserAuthorisedToReturnToolsWithoutNotification, bind$0040.IsUserToUserTransferSignatureRequired, bind$0040.IsReturnTransferSignatureRequired, bind$0040.ChatActive, bind$0040.Currency, msg.fields[0]));
                return [new State(new RequestedValue$1(1, [CustomerConfigurationUpdate__applyTo_Z37090ACA(update_1, matchValue.fields[0])]), FormState__startLoading(state.FormState)), updateCustomerConfiguration(update_1, (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(3, [Item_1])))];
            }
        }
    }
}

